import React from 'react';

interface MagazineNewButtonProps {
  onClick: () => void;
  label?: string;
}

const MagazineNewButton: React.FC<MagazineNewButtonProps> = ({
  onClick,
  label = 'New',
}) => (
  <button
    type="button"
    onClick={onClick}
    className="rounded bg-torch-primary px-4 py-2 text-sm font-medium text-white hover:bg-torch-primary-dark"
  >
    {label}
  </button>
);

export default MagazineNewButton;
